@if (device$ | async; as device) {
  <app-requests
    [device]="device"
  class="requests"></app-requests>
}
